export default __webpack_public_path__ + "static/media/TWICE 'Alcohol-Free'.e78371d5.webm";